<template>
  <donut-chart08-template
    :board-ids="[242]"
    :data-type="dataType"
    field-code="workplace-material"
    :graph-id="62"
    title="(원료·제조물 사업장) 비상조치계획수립 현황"
    unit="건"/>
</template>

<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart62',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
